var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "report-problem": true,
        mobile: _vm.isMobile(_vm.$mq)
      }
    },
    [
      _c("transition", { attrs: { name: "fade-fast", mode: "out-in" } }, [
        _vm.showingReportProblem
          ? _c(
              "div",
              { key: "popover", staticClass: "popover" },
              [
                _c(
                  "transition",
                  { attrs: { name: "fade-fast", mode: "out-in" } },
                  [
                    _vm.popoverState === "default"
                      ? _c("div", { key: "default" }, [
                          _c("header", [
                            _c("h4", [_vm._v("Report a problem")]),
                            _vm._v(" "),
                            _c("button", {
                              staticClass: "x b-sprite-quiz-v3-x-black-large",
                              on: { click: _vm.handleClosePopover }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "form",
                            {
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.handleChooseCategory($event)
                                }
                              }
                            },
                            [
                              _c("label", { staticClass: "radio" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.categoryChoice,
                                      expression: "categoryChoice"
                                    }
                                  ],
                                  attrs: {
                                    type: "radio",
                                    name: "category",
                                    value: "technical"
                                  },
                                  domProps: {
                                    checked: _vm._q(
                                      _vm.categoryChoice,
                                      "technical"
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.categoryChoice = "technical"
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span"),
                                _vm._v(
                                  "\n              Something is broken or missing.\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("label", { staticClass: "radio" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.categoryChoice,
                                      expression: "categoryChoice"
                                    }
                                  ],
                                  attrs: {
                                    type: "radio",
                                    name: "category",
                                    value: "content"
                                  },
                                  domProps: {
                                    checked: _vm._q(
                                      _vm.categoryChoice,
                                      "content"
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.categoryChoice = "content"
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span"),
                                _vm._v(
                                  "\n              I'm confused or don't really get what's going on here.\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("footer", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-black",
                                    attrs: {
                                      disabled: _vm.categoryChoice === null
                                    }
                                  },
                                  [_vm._v("Continue")]
                                )
                              ])
                            ]
                          )
                        ])
                      : _vm.popoverState === "subcategories"
                      ? _c("div", { key: "subcategories" }, [
                          _c("header", [
                            _c("h4", [_vm._v("Report a problem")]),
                            _vm._v(" "),
                            _c("button", {
                              staticClass: "x b-sprite-quiz-v3-x-black-large",
                              on: { click: _vm.handleClosePopover }
                            })
                          ]),
                          _vm._v(" "),
                          _c("h5", [_vm._v("Can you give more detail?")]),
                          _vm._v(" "),
                          _c(
                            "form",
                            {
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.handleChooseSubcategory($event)
                                }
                              }
                            },
                            [
                              _vm._l(
                                _vm.subcategoryChoicesByCategory[
                                  _vm.categoryChoice
                                ],
                                function(choiceValue) {
                                  return _c(
                                    "label",
                                    { key: choiceValue, staticClass: "radio" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.subcategoryChoice,
                                            expression: "subcategoryChoice"
                                          }
                                        ],
                                        attrs: {
                                          type: "radio",
                                          name: "subcategory"
                                        },
                                        domProps: {
                                          value: choiceValue,
                                          checked: _vm._q(
                                            _vm.subcategoryChoice,
                                            choiceValue
                                          )
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.subcategoryChoice = choiceValue
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span"),
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.subcategoryText[choiceValue]
                                              .choiceLabel
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _c("footer", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-black",
                                    attrs: {
                                      disabled: _vm.subcategoryChoice === null
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Continue\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn",
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.handleBackButton($event)
                                      }
                                    }
                                  },
                                  [_vm._v("Back")]
                                )
                              ])
                            ],
                            2
                          )
                        ])
                      : _vm.popoverState === "description"
                      ? _c("div", { key: "description" }, [
                          _c("header", [
                            _c("h4", [_vm._v("Report a problem")]),
                            _vm._v(" "),
                            _c("button", {
                              staticClass:
                                "arrow-down b-sprite-quiz-v3-arrow-down-large",
                              on: { click: _vm.closePopoverWithoutClearing }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "form",
                            {
                              staticClass: "description",
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.handleSubmitReport($event)
                                }
                              }
                            },
                            [
                              _c("label", { attrs: { for: "description" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.subcategoryText[_vm.subcategoryChoice]
                                      .descriptionLabel
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.description,
                                    expression: "description"
                                  }
                                ],
                                class: {
                                  "with-error": _vm.errorMessage !== null
                                },
                                attrs: {
                                  id: "description",
                                  placeholder: "Description",
                                  disabled: _vm.isSendingReport
                                },
                                domProps: { value: _vm.description },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.description = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("p", { staticClass: "error" }, [
                                _vm._v(_vm._s(_vm.errorMessage))
                              ]),
                              _vm._v(" "),
                              _c(
                                "transition",
                                { attrs: { name: "fade-fast" } },
                                [
                                  _vm.showDraftSavedMessage
                                    ? _c(
                                        "p",
                                        { staticClass: "draft" },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "icon b-sprite-quiz-v3-info",
                                            on: {
                                              mouseenter: function($event) {
                                                _vm.showDraftSavedTooltip = true
                                              },
                                              mouseleave: function($event) {
                                                _vm.showDraftSavedTooltip = false
                                              }
                                            }
                                          }),
                                          _vm._v(
                                            "\n                Draft saved.\n                "
                                          ),
                                          _c(
                                            "transition",
                                            { attrs: { name: "fade-fast" } },
                                            [
                                              _vm.showDraftSavedTooltip &&
                                              !_vm.isMobile(_vm.$mq)
                                                ? _c(
                                                    "span",
                                                    { staticClass: "tooltip" },
                                                    [
                                                      _vm._v(
                                                        "\n                    Feel free to close this report and return later.\n                  "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c("footer", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-black",
                                    attrs: { disabled: _vm.isSendingReport }
                                  },
                                  [_vm._v("Submit report")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn",
                                    attrs: { disabled: _vm.isSendingReport },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.handleBackButton($event)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Back\n              "
                                    )
                                  ]
                                )
                              ])
                            ],
                            1
                          )
                        ])
                      : _vm.popoverState === "done"
                      ? _c("div", { key: "done" }, [
                          _c("header", [
                            _c("h4", [_vm._v("Thank you")]),
                            _vm._v(" "),
                            _c("button", {
                              staticClass: "x b-sprite-quiz-v3-x-black-large",
                              on: { click: _vm.handleClosePopover }
                            })
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "We appreciate your feedback and will look into this soon."
                            )
                          ]),
                          _vm._v(" "),
                          _c("footer", [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-black",
                                on: { click: _vm.handleClosePopover }
                              },
                              [_vm._v("Okay!")]
                            )
                          ])
                        ])
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }